import styled from "styled-components";
import { colorPalette, typeScale } from "../../../../utils/theme";

export const HeroSection = styled.section`
  padding-top: 60px;
  padding-bottom: 60px;

  @media (max-width: 767.98px) {
    padding-left: 16px;
    padding-right: 16px;
    padding-top: 30px;
    padding-bottom: 30px;
  }
`;

export const Headline = styled.h1`
  margin-bottom: 8px;
  color: ${colorPalette.textMain};
  ${typeScale.headingLMain};

  @media (max-width: 767.98px) {
    ${typeScale.headingMain};
  }
`;

export const Subtitle = styled.h1`
  margin-bottom: 8px;
  color: ${colorPalette.textDark};
  ${typeScale.headingXS};

  @media (max-width: 767.98px) {
    ${typeScale.bodySM};
  }
`;

// Features Section
export const FeatureSection = styled.section`
  padding-top: 60px;
  padding-bottom: 60px;

  @media (max-width: 767.98px) {
    padding-left: 16px;
    padding-right: 16px;
    padding-top: 30px;
    padding-bottom: 30px;
  }
`;

export const FeatureImage = styled.img`
  width: 100px;
  margin-bottom: 18px;
  cursor: pointer;
`;

export const FeatureHeadline = styled.h4`
  margin-bottom: 8px;
  color: ${colorPalette.textMain};
  ${typeScale.headingMain}

  @media (max-width: 767.98px) {
    ${typeScale.headingSMMain}
  }
`;

export const FeatureDescription = styled.p`
  margin: 0;
  color: ${colorPalette.textDark};
  ${typeScale.bodySM};

  @media (max-width: 767.98px) {
    margin-bottom: 40px;
  }
`;

export const PremiumIncludesBasic = styled.p`
  margin: 0;
  color: ${colorPalette.textDark};
  ${typeScale.bodySM};

  @media (max-width: 767.98px) {
    ${typeScale.bodyXS};
  }
`;
